<template>
  <div
    ref="popupContainerRef"
    v-click-outside="vcoConfig"
    class="popup-container improve-slide-search"
  >
    <div class="main-content">
      <div class="slides-container">
        <AISlideGeneratorSideLeft
          :isGeneratorContentVisible="isGeneratorContentVisible"
          @handleDiveInQuiz="handleDiveInQuiz"
        />

        <SlideTypeList
          v-if="isTreatmentSlideTypePreview && !isGeneratorContentVisible"
          :wrapperId="wrapperId"
          class="overflow-y-auto bg-base-0 px-5 py-8"
        />

        <SlideTabs
          v-if="!isTreatmentSlideTypePreview && !isGeneratorContentVisible"
          :wrapperId="wrapperId"
          @handleSelectSlideType="handleSelectSlideType"
        />

        <ImportSheet v-if="!isGeneratorContentVisible" />

        <div
          ref="previewRef"
          class="preview"
          :class="{
            visual: isTreatmentSlideTypePreview,
            'ai-generator-collapsed': isAIGeneratorCollapsed
          }"
        >
          <div class="preview-content">
            <CanvasPreview :wrapperId="wrapperId" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import SelectSlideTypeMixin from '@/mixins/slide/SelectSlideTypeMixin'
import SlideTabs from './SlideTabs.vue'
import AISlideGeneratorSideLeft from './OpenAI/AISlideGeneratorSideLeft.vue'
import CanvasPreview from '@/components-v2/common/canvas-preview/CanvasPreview.vue'
import SlideTypeList from '@/components-v2/presentation-editor/new-slide/SlideTypeList.vue'

import EventBus from '@/eventBus'
import ImportSheet from '@/components-v2/presentation-editor/import-sheet/ImportSheet.vue'

export default {
  components: {
    SlideTabs,
    AISlideGeneratorSideLeft,
    CanvasPreview,
    ImportSheet,
    SlideTypeList,
  },
  mixins: [SelectSlideTypeMixin],
  props: {
    closeSlideSearchPopup: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      wrapperId: 'slide-search-popup',
      isGeneratorContentVisible: false,
      isShowPreview: false,
      vcoConfig: {
        handler: this.handler,
        middleware: this.middleware,
      },
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    ...mapGetters(['isTreatmentSlideTypePreview']),
    isAIGeneratorCollapsed() {
      return this.currentUser
        && this.currentUser.rememberSettings
        && this.currentUser.rememberSettings.isAIGeneratorCollapsed
    },
  },
  created() {
    EventBus.$on('slide-search-popup:close', this.closeSlideSearchPopup)
    EventBus.$on('handleHoverOnSlideType', this.handleHoverOnSlideType)
  },
  mounted() {
    if (this.$store.state.createdPresentationFromQuizHintsBanner) {
      const payload = { // create a quiz slide
        item: {
          name: 'Pick Answer',
          icon: 'fas fa-tasks',
          type: 'pickAnswer',
          slideType: null,
          desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
          label: 'Quiz',
          ahaIcon: 'pick-answer',
          ahaIconWhite: 'pick-answer-w',
          preview: 'pickAnswer',
          previewUrl: '/723e47a009d5db8436363ef227c6577a.svg',
          videoTutorialUrl: 'https://youtu.be/RGX2dmuvTEA',
          error: false,
          isLoading: false,
        },
        property: 'quiz-hints-banner',
      }
      this.handleSelectSlideType(payload)
    }
  },
  destroyed() {
    EventBus.$off('slide-search-popup:close', this.closeSlideSearchPopup)
  },
  methods: {
    handleSelectSlideType(payload) {
      this.selectSlideType(payload) // mixin SelectSlideType
      this.closeSlideSearchPopup()
    },
    handleHoverOnSlideType(item, mode) {
      if (this.$store.state.isTouchScreen) return

      this.isShowPreview = mode === 'over'
    },
    handleDiveInQuiz(status = true) {
      this.isGeneratorContentVisible = status
    },
    handler() {
      this.closeSlideSearchPopup()
    },
    middleware(event) {
      return !event.target.closest('.new-slide-context-cta') &&
        !event.target.closest('.slides-container') &&
        !event.target.closest('.aha-modal__content')
    },
  },
}
</script>

<style lang="scss" scoped>
.popup-container {
  position: relative;
  display: flex;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  width: 500px;
  height: calc(100% - 36px);
  margin-top: 16px;
  margin-left: 20px;
}

.main-content {
  height: 100%;
  width: 100%;
}

.slides-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.preview {
  pointer-events: none;
  position: absolute;
  width: 42vw;
  max-width: 676px;
  height: auto;
  top: 232px;
  left: calc(100% + 20px);
  box-shadow: 0px 4px 27px rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  aspect-ratio: 676 / 578 !important;
  overflow: hidden;

  &.visual {
    top: 120px;
    aspect-ratio: 1622 / 906 !important;

    &.ai-generator-collapsed {
      top: 126px;
    }
  }
}
</style>
